import { Link } from 'gatsby';
import React from 'react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';

const Home = () => {
  return (
    <>
      <section className="hero is-fullheight-with-navbar is-link">
        <Seo />
        <div className="hero-body has-text-centered is-justify-content-center is-flex-direction-column">
          <p className="title">React Interviews</p>
          <p className="subtitle">
            This website will help you prepare for react interviews
            <i> so fast...</i>
          </p>
          <div>
            <a
              className="mb-2 mr-2 button is-button is-large is-danger"
              href="/interview-questions/reactjs-question-answer/"
            >
              React Question
            </a>
            <a
              href="/company-interviews"
              className="mb-2 button is-button is-large is-white"
            >
              <div className="is-flex is-flex-direction-column">
                <span className="title has-text-black is-4">
                  Comapny Interviews
                </span>
              </div>
            </a>
          </div>
        </div>

      </section>
      <section className='container mt-4'>
        <Link to="/company-interviews/wells-fargo">
        <div className="tile is-ancestor">
          <div className="tile is-vertical is-8">
            <div className="tile">
              <div className="tile is-parent is-vertical">
                <article className="tile is-child notification is-primary">
                  <p className="title">Wells Fargo</p>
                  <p className="subtitle">Wells Fargo & Company is an American multinational financial services company with corporate headquarters in San Francisco, California, operational headquarters in Manhattan, and managerial offices throughout the United States and internationally.</p>
                </article>
              </div>
            </div>
          </div>
        </div>
        </Link>
      </section>
    </>
  );
};

const IndexPage = () => {
  return (
    <>
      <Layout>
        <Home />
      </Layout>
    </>
  );
};

export default IndexPage;
